import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginPage from "@/components/login-page";
import MainPage from "@/components/main-page";
import axios from "axios";
import RegistrationPage from "@/components/registration-page";

Vue.use(VueRouter)

const routes = [
    {
        path: "/",
        name: "home",
        component: MainPage,
        meta: {
            requiresAuth: true
        },
        props: {
            email: String,
            guest: false
        }
    },
    {
        path: "/",
        name: "guest",
        component: MainPage,
        props: {
            guest: true
        }
    },
    {
        path: "/login",
        name: "login",
        component: LoginPage
    },
    {
        path: "/registration",
        name: "registration",
        component: RegistrationPage
    }
]

const router = new VueRouter({
    routes:routes
})

router.beforeEach((to, from, next) => {
    if (to.name === "login" || to.name === "registration") {
        axios
            .post("/eco-passport/check-session", {})
            .then(() => {
                router.replace({path: '/', name: 'home'})
            })
            .catch(() => {
            });
    }
    if (to.matched.some(record => record.meta.requiresAuth)) {
        axios
            .post("/eco-passport/check-session")
            .then((res) => {
                routes[0].props.email = res.data.email.data
                next()
            })
            .catch(e => {
                if (e.response.status === 401) {
                    next({
                        path: '/login',
                        name: 'login',
                        params: {nextUrl: from}
                    })
                }
            });
    } else {
        next()
    }

})

export default router

